import React, { type ReactNode } from "react";

import clsx from "clsx";
import { motion } from "framer-motion";

import { NavLink, type NavLinkProps } from "./nav-link";

interface SidebarItemProps extends Omit<NavLinkProps, "children"> {
  readonly isHidden?: boolean;
  readonly icon: ReactNode;
  readonly expanded: boolean;
  readonly useDevelopmentAnalyticsData: boolean;
  readonly children: ReactNode;
  readonly isNew?: boolean;
}

export const sidebarIconClasses = (
  useDevelopmentAnalyticsData: boolean,
  isActive = false,
) =>
  clsx(
    "transform transition-colors ease-in h-10 w-10 flex-center rounded-full",
    {
      "bg-cosmic": isActive && !useDevelopmentAnalyticsData,
      "group-hover/item:bg-cosmic+2": !useDevelopmentAnalyticsData,
      "bg-venus+2": isActive && useDevelopmentAnalyticsData,
      "group-hover/item:bg-venus+1": useDevelopmentAnalyticsData,
    },
  );

export const SidebarItem = ({
  isHidden,
  icon,
  expanded,
  children,
  useDevelopmentAnalyticsData,
  isNew,
  ...props
}: SidebarItemProps) => {
  if (isHidden) {
    return null;
  }
  return (
    <NavLink {...props}>
      {({ isActive }) => (
        <div className="flex flex-row items-center">
          <div className="relative">
            <span
              className={sidebarIconClasses(
                useDevelopmentAnalyticsData,
                isActive,
              )}
            >
              {icon}
            </span>
            {isNew && (
              <div
                className={
                  "absolute -bottom-2  left-1/2  transform -translate-x-1/2 " +
                  "text-xxs border-interstellar border-2 bg-pluto text-interstellar rounded-lg px-1 "
                }
              >
                NEW
              </div>
            )}
          </div>
          <motion.span
            className={clsx("ml-2", {
              "pointer-events-none hidden": !expanded,
            })}
            animate={{ opacity: expanded ? 1 : 0 }}
            transition={{ duration: 0.1 }}
          >
            {children}
          </motion.span>
        </div>
      )}
    </NavLink>
  );
};
